// @view/authentication/PasswordResetComplete.view.tsx

import React from "react";
import * as styles from "@styles/PasswordReset.css";
import { Button } from "@components/ui/button";
import { Card, CardContent, CardTitle } from "@components/ui/card";

import * as IO from "@ps-bridge/interop/io";
import * as Option from "@utils/Option";
import type { PasswordResetCompleteViewProps } from "@ps-bridge/contracts/passwordResetComplete";
import { ok } from "@ps-bridge/ok";
import PasswordResetLogoPanel from "@view/panels/authentication/PasswordResetLogo.panel";
import PasswordResetCompleteBodyPanel from "@view/panels/authentication/PasswordResetCompleteBody.panel";

const PasswordResetCompleteView: React.FC<PasswordResetCompleteViewProps> = ({
    password,
    confirmPassword,
    onPasswordChange,
    onConfirmPasswordChange,
    onSubmit,
    onNavigateToRequest,
    bodyPhase,
    logoPhase,
    logoUri,
}) => {
    return (
        <div className={styles.page} data-testid="page-password-reset-complete" data-page-state="ready">
            <Card className={styles.card}>
                <CardContent>
                    <PasswordResetLogoPanel phase={logoPhase} logoUri={logoUri} />
                    <CardTitle className={styles.title}>Choose a new password</CardTitle>
                    <PasswordResetCompleteBodyPanel
                        phase={bodyPhase}
                        password={password}
                        confirmPassword={confirmPassword}
                        onPasswordChange={onPasswordChange}
                        onConfirmPasswordChange={onConfirmPasswordChange}
                        onSubmit={onSubmit}
                    />
                    <Button
                        variant="ghost"
                        className={styles.textButton}
                        onClick={() => IO.run(onNavigateToRequest(ok))}
                        asChild={Option.none()}
                        data-testid="password-reset-complete-request-new-link"
                    >
                        Request a new link
                    </Button>
                </CardContent>
            </Card>
        </div>
    );
};

export default PasswordResetCompleteView;
